// extracted by mini-css-extract-plugin
export default {"heartIcon":"CompaniesColumns_heartIcon__zexJP","heartIconSaved":"CompaniesColumns_heartIconSaved__ydXFc","savedHeartIcon":"CompaniesColumns_savedHeartIcon__RDnVX"};